import React, {Component} from "react";
import "./QualityComplaintHeader.css";
import {FormattedMessage} from "react-intl";
import InitialQuotationState from "../../../../Site/QuotationForm/InitialQuotationState";

const optionsInEN = [
    {text : "Today" , value : 1},
    {text : "This Week" , value : 2},
    {text : "This Month" , value : 3},
    {text : "This Year" , value : 4},
    {text : "Date Range" , value : 5},
    {text : "All" , value : null}
];
const optionsInJP = [
    {text : "今日" , value : 1},
    {text : "今週" , value : 2},
    {text : "今月" , value : 3},
    {text : "今年" , value : 4},
    {text : "期間" , value : 5},
    {text : "全て" , value : null}
];

const FromToDateToggle = (props) => {
    return(
        <div>
            <div className="col-md-1 no-padding">
                <div className="all-inquiry-header-label">
                    <FormattedMessage id="app.admin-inquiry-header.from"
                                      defaultMessage="From"
                                      description=""/>
                </div>
            </div>
            <div className="col-md-2 no-padding-right">
                <input className="all-inquiry-header-search-input" max="9999-12-31"
                       name="from" type="date" onChange={props.handlePeriodChange}/>
            </div>
            <div className="col-md-1">&nbsp;</div>
            <div className="col-md-1 no-padding">
                <div className="all-inquiry-header-label no-padding">
                    <FormattedMessage id="app.admin-inquiry-header.to"
                                      defaultMessage="To"
                                      description=""/>
                </div>
            </div>
            <div className="col-md-2 no-padding-right">
                <input className="all-inquiry-header-search-input" max="9999-12-31"
                       name="to" type="date" onChange={props.handlePeriodChange}/>
            </div>
        </div>
    )
};

class QualityComplaintHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            period : null,
            lang : "ja"
        };

        this.handlePeriodChange = this.handlePeriodChange.bind(this);
    }

    componentDidMount() {
        let lang = localStorage.getItem("setLang");
        this.setState({
            lang
        })
    }

    handlePeriodChange = (periodChangeEvent) => {

        if(periodChangeEvent.target.name === "period-input"){
            this.setState({
                period : periodChangeEvent.target.value
            },()=>console.log("CHANGE PERIODd ===> "));

        }

        if(periodChangeEvent.target.name == "from"){
            this.props.setSearchTimeRange("from",periodChangeEvent.target.value);
        }else if(periodChangeEvent.target.name == "to"){
            this.props.setSearchTimeRange("to",periodChangeEvent.target.value);
        }else {
            this.props.setSearchTimePeriod(periodChangeEvent.target.value);
        }
    };

    render() {
        let lang = InitialQuotationState.lang;

        return (
            <div>

                <div className="row">
                    <div className="col-md-2 responsive-no-padding">
                        <div className="all-inquiry-header-label">
                            <FormattedMessage id="app.admin-inquiry-header.status"
                                              defaultMessage="Status:"
                                              description=""/></div>
                    </div>
                    <div className="col-md-10 no-padding-right">

                        <div className="row">
                            <div className="col-md-1 custom-col-1">
                                <input type="checkbox"
                                       value={2}
                                       onChange={this.props.setSearchStatus}
                                       defaultChecked={true}
                                />
                            </div>
                            <div className="col-md-2 admin-inquiry-header-new">
                                未回答
                            </div>
                            <div className="col-md-1 custom-col-1">
                                <input type="checkbox"
                                       value={0}
                                       onChange={this.props.setSearchStatus}
                                />
                            </div>
                            <div className="col-md-2 admin-inquiry-header-replied">
                                回答済
                            </div>
                            <div className="col-md-1">
                               {/* <input type="checkbox"
                                       value={3}
                                       onChange={this.props.setSearchStatus}
                                />*/}
                            </div>
                            <div className="col-md-2 admin-inquiry-header-closed">
                               {/* <FormattedMessage id="app.admin-inquiry-header.close"
                                                  defaultMessage="Close"
                                                  description=""/>*/}
                            </div>
                            <div className="col-md-3"></div>
                        </div>
                    </div>


                </div>
                <div className="col-md-12">&nbsp;</div>
                <div className="row">

                    <div className="col-md-2 responsive-no-padding">
                        <div className="all-inquiry-header-label">
                            <FormattedMessage id="app.admin-inquiry-header.date-period"
                                              defaultMessage="Date Period"
                                              description=""/>
                        </div>
                    </div>
                    <div className="col-md-2 no-padding-right">
                        <select name="period-input" onChange={this.handlePeriodChange} className="form-control all-inquiry-header-search-input">
                            {lang == "ja" ?
                                optionsInJP.map((optionJA) => {
                                    return <option key={optionJA.value} value={optionJA.value}>{optionJA.text}</option>
                                }) :

                                optionsInEN.map((optionEN) => {
                                    return <option key={optionEN.value} value={optionEN.value}>{optionEN.text}</option>
                                })
                            }
                        </select>

                    </div>

                    <div className="col-md-1">&nbsp;</div>
                    {this.state.period == 5 ? <FromToDateToggle handlePeriodChange = {this.handlePeriodChange} setSearchTimeRange = {this.props.setSearchTimeRange}/> : ""}
                </div>

                <br/>


            </div>
        )
    }
}

export default QualityComplaintHeader;



// WEBPACK FOOTER //
// ./src/components/Admin/NewQualityComplaint/QualityComplaintTable/QualityComplaintHeader/QualityComplaintHeader.js